import React, { useEffect, useState, useCallback } from "react";
import SideBar from "../../components/SideBar/SideBar";
import TopNav from "../../components/TopNav/TopNav";
import TableColumn from "../../components/TableColumn/TableColumn";
import api from "../../services/api";
import { format } from "date-fns";
import "./PromoterDemos.scss";

const PromoterDemos = () => {
  const [leads, setLeads] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    Number(localStorage.getItem("ListCurrentPagePromoterDemos")) || 1
  );
  const records = 20;

  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("null");

  const columns = ["Name", "Instagram", "Phone", "Email", "Code", "Visits", "Status", "Date"];
  const sortableColumns = ["Name", "Status"];
  const sortColumnsMapping = {
    Name: "name",
    Status: "status",
  };

  const formatDate = (date) => {
    try {
      return format(new Date(date), "MMM d, yyyy");
    } catch { return ""; }
  };

  const fetchLeads = useCallback(async (page) => {
    try {
      const response = await api.get("/promoter-demos", {
        params: {
          page,
          records,
          sort_column: sortBy,
          sort: sortDirection,
        },
      });

      const rows = (response.data.data || []).map((lead) => ({
        _id: lead._id,
        Name: lead.name,
        Instagram: lead.ig,
        Phone: lead.phone,
        Email: lead.email,
        Code: <span className="demo-code">{lead.promo_code}</span>,
        Visits: lead.visit_count || 1,
        Status: (
          <span className={`status-badge ${lead.status || 'new'}`}>
            <span className="dot" />
            {lead.status || 'new'}
          </span>
        ),
        Date: lead.created_at ? formatDate(lead.created_at) : "",
      }));

      setLeads(rows);
      setTotalPages(response.data.total || 0);
    } catch (err) {
      console.log(`Error fetching promoter demo leads: ${err}`);
    }
  }, [sortBy, sortDirection]);

  useEffect(() => {
    fetchLeads(currentPage);
  }, [currentPage, fetchLeads]);

  const fetchAllData = async () => {
    try {
      const response = await api.get("/promoter-demos", {
        params: { records: 9999999999 },
      });
      return (response.data.data || []).map((lead) => ({
        Name: lead.name,
        Instagram: lead.ig,
        Phone: lead.phone,
        Email: lead.email,
        Code: lead.promo_code,
        Visits: lead.visit_count || 1,
        Status: lead.status || 'new',
        Date: lead.created_at ? formatDate(lead.created_at) : "",
      }));
    } catch (err) {
      console.log(`Error fetching all data: ${err}`);
      return [];
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    localStorage.setItem("ListCurrentPagePromoterDemos", page);
  };

  const handleSort = (columnName) => {
    const backendColumn = sortColumnsMapping[columnName];
    if (sortBy === backendColumn) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(backendColumn);
      setSortDirection("asc");
    }
  };

  return (
    <main>
      <TopNav />
      <div className="main-container">
        <SideBar />
        <article className="page-content">
          <section className="promoter-demos">
            <TableColumn
              title="Promoter Demo Leads"
              columns={columns}
              data={leads}
              sortableColumns={sortableColumns}
              hasExport={true}
              hasSearch={false}
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              records={records}
              fetchAllData={fetchAllData}
              onSort={handleSort}
            />
          </section>
        </article>
      </div>
    </main>
  );
};

export default PromoterDemos;
